import { Context } from '../filtersMachine';
import fetchBookingStatus from '@/api/bookingStatuses';

const fetchCriteriaOptions = async (ctx: Context, evt) => {
    if (evt.payload.criteria === 'BookingStatus') {
        const response = await fetchBookingStatus();

        return {
            ...evt,
            payload: {
                ...evt.payload,
                isNew: true,
                meta: response,
            },
        };
    }

    return evt;
};

export default fetchCriteriaOptions;
